import RouteName from '@/models/enums/RouteName'

export default [
  {
    path: '/collections',
    name: RouteName.Collections,
    component: () => import('@/pages/Collections/CollectionsList'),
    meta: {
      breadcrumb: {
        label: 'Подборки',
        parent: RouteName.Directory,
      },
    },
  },
  {
    path: '/collections/create',
    name: 'collectionsCreate',
    component: () => import('@/pages/Collections/CollectionsCreate'),
    meta: {
      breadcrumb: {
        label: 'Новая подборка',
        parent: RouteName.Collections,
      },
    },
  },
  {
    path: '/collections/:id',
    name: 'collectionsEdit',
    component: () => import('@/pages/Collections/CollectionsSingle'),
    props: { isEdit: false },
    meta: {
      breadcrumb: {
        label: 'Редактирование',
        parent: RouteName.Collections,
      },
    },
  },
]
